import { render } from "./ButtonMenu.vue?vue&type=template&id=0c12c865"
import script from "./ButtonMenu.vue?vue&type=script&lang=js"
export * from "./ButtonMenu.vue?vue&type=script&lang=js"

import "./ButtonMenu.vue?vue&type=style&index=0&id=0c12c865&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__